import { render } from "./GenerateMissingSB.vue?vue&type=template&id=a59735d2&scoped=true"
import script from "./GenerateMissingSB.vue?vue&type=script&lang=js"
export * from "./GenerateMissingSB.vue?vue&type=script&lang=js"

import "./GenerateMissingSB.vue?vue&type=style&index=0&id=a59735d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59735d2"]])

export default __exports__